<template>
  <main class="main">
    <article class="first-entry home-info">
      <header class="entry-header">
        <h1>Let's start 🚀</h1>
      </header>
      <div class="entry-content">
        <ol>
          <li>
            <p>Hey! forms are boring, for ideas, business, or a simple hello, drop me a line at <strong><a href="#">davidlares@protonmail.com</a></strong></p>
          </li>
          <li>
            <p>You can check my resume 🏅 in <strong><a href="https://resume.io/r/jRur2wt" target="_blank">this</a></strong> link</p>
          </li>
          <li>
            <p>Need a video call? book your spot in <strong><a href="https://calendly.com/davidlares/30min" target="_blank">Calendly</a></strong></p>
          </li>
        </ol>
      </div>
    </article>
  </main>
</template>
<script>
export default {
  name: 'Contact'
}
</script>
